<template>
    <div class="container">
        <div class="Income__content container-inner">
            <TitleSection
                title="Estimate of income protection"
            />
            <Result
                url="https://life.nib.com.au/income-protection-insurance/quote"
                type="Income protection"
                label="Income (per month):"
                :result="result"
                @reset="reset"
            />
        </div>

        <slot />
    </div>
</template>

<script>
  import { calculateCover } from './../calculators/income-detailed';
  import incomeExpress from './../calculators/income-express';
  import TitleSection from '../components/TitleSection.vue';
  import Result from '../components/Result.vue';
  import * as track from '@/utilities/tracking';

  export default {
    name: 'results',

    components: {
        TitleSection,
        Result
    },

    methods: {
        reset() {
            track.resetIncome();
            this.$store.commit('reset');
            this.$router.push({ path: `/income`});
        }
    },
    mounted() {
        track.completeIncome();
    },
    computed: {
        store() {
            return this.$store
        },
        result() {
            const grossIncomeAnnual = this.$store.state.income || this.$store.state.customIncome;
            const grossIncomeOtherAnnual = (this.$store.state.incomeOther || this.$store.state.customIncomeOther);
            const debtRepaymentMonthly = this.$store.state.debtRepayment || this.$store.state.customDebtRepayment;
            const householdExpenseWeekly = this.$store.state.expenses || this.$store.state.customExpenses;

            let result
            if (this.$store.state.calculator == 'express') {
                result = incomeExpress(grossIncomeAnnual);
            } else {
                result = calculateCover(grossIncomeAnnual, grossIncomeOtherAnnual, debtRepaymentMonthly, householdExpenseWeekly);
            }

            return '$' + (Math.round(result)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
  }
</script>

<style lang="scss" scoped>

    .Income__content {
        margin: 0 auto;
        text-align: center;
        padding-bottom: 20px;
    }

    .Income__list {
        max-width: 480px;
        margin-bottom: 30px;
        margin-top: 70px;
        margin-left: auto;
        margin-right: auto;
        padding: 0;
        list-style: none;
        text-align: left;
        font-size: 18px;
    }

    .Income__list:after {
        content: "";
        display: table;
        clear: both;
    }

    .Income__list li {
        float: left;
        width: 100%;
        margin-bottom: 1.5em;
        padding-bottom: 0.25em;
        border-bottom: 1px solid rgba(0,0,0,0.2);
    }

    .Income__list strong {
        float: right;
    }
</style>
